import { render, staticRenderFns } from "./LeadsReassigned.vue?vue&type=template&id=dafc20a4"
import script from "./LeadsReassigned.vue?vue&type=script&lang=js"
export * from "./LeadsReassigned.vue?vue&type=script&lang=js"
import style0 from "./LeadsReassigned.vue?vue&type=style&index=0&id=dafc20a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports